import * as THREE from "three";
import Hero from "@/models/Xterminate/Hero";
import Villain from "@/models/Xterminate/Villain";
import Background from "@/models/Xterminate/Background";
import Weapon from "@/models/Xterminate/Weapon";

export default function(camera, vueBus) {
  function Wall(x2, y2, z2, height, material) {
    const geometry = new THREE.BoxGeometry(1, height, 1);

    Object.setPrototypeOf(this, new THREE.Mesh(geometry, material));
    this.position.set(x2, y2, z2);
  }

  const scene = new THREE.Scene();
  const textureLoader = new THREE.TextureLoader();

  // Ground definition
  const map = [];
  map[0] = "pppppppppppppppppppppppqqqqqqqqqqqqqqqqqqqqqqdddqq";
  map[1] = "p           pppph                          q  a  q";
  map[2] = "d   v        ppp                           q     q";
  map[3] = "da pppp  p     p  p  pppqq  qqq    qqqqqq  q  q  q";
  map[4] = "d     p   p    p  p  p   q     q    qqqqq  q  q  q";
  map[5] = "p      p   ppppp  p  p   q      q    qqqq  q  q  q";
  map[6] = "pppp    p      p  p  pp  q  q    q    qqq  q  q  q";
  map[7] = "p  pp v  p     p  p  p   q  qq    q    qq     q  q";
  map[8] = "p  ppp   pppp  p  p  p   q  qqq    q    q     q  q";
  map[9] = "p     p  p  p  p  p  p  qq     q    q  v qqq  q  q";
  map[10] = "p      p p  p  p  p  p   q      q    q    qq  q  q";
  map[11] = "p  p    pp     p  p  p   q  q    q    q    qqqq  q";
  map[12] = "p  pp    p     p  p  pp  q  qq    q    q         q";
  map[13] = "p  ppp   p  p  p  p  p   q  qqq    q    q        q";
  map[14] = "p     p  p  p  p  p  p   q  qqqq    qqqqqqqqqqqqqq";
  map[15] = "p     p  p  p  p  p  p  qq           v           q";
  map[16] = "pppp  p  p  p  p  p  p   q    v                  q";
  map[17] = "p  p  p  p  p  p  p  p   q  qqqqqqqqqqqqqqqqqqq  q";
  map[18] = "p  p  p  p  p  p  p   p  qqq                     q";
  map[19] = "p  p  p  p  p  p  p   p                          q";
  map[20] = "p     p  p  p  p  ppppp       qqqqqqqqqqqqqqqqqqqq";
  map[21] = "p        p  p       ppp  qqq                     q";
  map[22] = "pppp     p  p       p      q                     q";
  map[23] = "ppppppp  p  ppppppppp      qqqqqqqqqqqqqqqqqqqqqqq";
  map[24] = "p     p                 T     q                  q";
  map[25] = "s     s                       r                  r";
  map[26] = "s  s  s  ssssssssssss      r  rrrrr  rrrrrrrrrr  r";
  map[27] = "s  ss s             s      r  r               r  r";
  map[28] = "s  ssss             sss  rrr  r               r  r";
  map[29] = "s  sssssssssssssss    s  rr   rrrrrrrrrrrrrr  r  r";
  map[30] = "s  s        sssss    s   rr   r            r  r  r";
  map[31] = "s  s        ssss    s    rr  r             r  r  r";
  map[32] = "s  s  ssss  sss    s    r    r   rrrrrrrr  r  r  r";
  map[33] = "s  s  sss   ss    s    s     r  rrrrrrrrr  r  r  r";
  map[34] = "s  s  ss    s    s    s    rrr  rr v    r  r  r  r";
  map[35] = "s  s  s    s    s    s    r     rr      r  r  r vr";
  map[36] = "s  s  s   s    s    s    r      rr   t     r  r  r";
  map[37] = "s  s  s  s    s    s    r   rrrrrr         r  r  r";
  map[38] = "s  s  s  s   s    s    s    r           r  r  r  r";
  map[39] = "s  s  s  s  s    s    s    rr           r  r  r  r";
  map[40] = "s  s  s  s  s   s    s    rrr  rrrrrrrrrr  r  r  r";
  map[41] = "s  s  s  s  s  s    s    rrrr          v   r  r  r";
  map[42] = "s  s  s     s  s   ss   rrrrr              r  r  r";
  map[43] = "s  s  s     s  s  sss  srrrrrrrrrrrrrrrrrrrr  r  r";
  map[44] = "s vs  sssssss  s                              r  r";
  map[45] = "s  s  ssssss   s                              r  d";
  map[46] = "s  s  sssss   ssssssssssrrrrrrrrrrrrrrrrrrrrrrr ad";
  map[47] = "s     ssss   s                                   d";
  map[48] = "s  a  sss   s   v                                r";
  map[49] = "ssdddsssssssssssssssssssrrrrrrrrrrrrrrrrrrrrrrrrrr";

  const textureBlood = textureLoader.load("/img/3DTextures/xterminate/game/blood.jpg");
  textureBlood.wrapS = THREE.RepeatWrapping;
  textureBlood.wrapT = THREE.RepeatWrapping;
  textureBlood.repeat.set(1, 1);
  const textureDarkFloor = textureLoader.load("/img/3DTextures/xterminate/game/darkFloor.jpg");
  textureDarkFloor.wrapS = THREE.RepeatWrapping;
  textureDarkFloor.wrapT = THREE.RepeatWrapping;
  textureDarkFloor.repeat.set(1, 1);
  const textureDarkFloor2 = textureLoader.load("/img/3DTextures/xterminate/game/darkFloor2.jpg");
  textureDarkFloor2.wrapS = THREE.RepeatWrapping;
  textureDarkFloor2.wrapT = THREE.RepeatWrapping;
  textureDarkFloor2.repeat.set(1, 1);
  const textureWallSkull = textureLoader.load("/img/3DTextures/xterminate/game/wallSkull.jpg");
  textureWallSkull.wrapS = THREE.RepeatWrapping;
  textureWallSkull.wrapT = THREE.RepeatWrapping;
  textureWallSkull.repeat.set(1, 1);
  const textureWallSkull2 = textureLoader.load("/img/3DTextures/xterminate/game/wallSkull2.jpg");
  textureWallSkull2.wrapS = THREE.RepeatWrapping;
  textureWallSkull2.wrapT = THREE.RepeatWrapping;
  textureWallSkull2.repeat.set(1, 1);
  const textureGates = textureLoader.load("/img/3DTextures/xterminate/game/gates.jpg");
  textureGates.wrapS = THREE.RepeatWrapping;
  textureGates.wrapT = THREE.RepeatWrapping;
  textureGates.repeat.set(1, 1);
  const textureFire = textureLoader.load("/img/3DTextures/xterminate/game/fire.jpg");
  textureFire.wrapS = THREE.RepeatWrapping;
  textureFire.wrapT = THREE.RepeatWrapping;
  textureFire.repeat.set(1, 1);
  const textureSkull = textureLoader.load("/img/3DTextures/xterminate/game/skull.jpg");
  textureSkull.wrapS = THREE.RepeatWrapping;
  textureSkull.wrapT = THREE.RepeatWrapping;
  textureSkull.repeat.set(0.5, 0.5);

  const materialBlood = new THREE.MeshLambertMaterial({ map: textureBlood });
  const materialDarkFloor = new THREE.MeshLambertMaterial({
    map: textureDarkFloor,
    transparent: true,
    opacity: 0.9
  });
  const materialDarkFloor2 = new THREE.MeshLambertMaterial({ map: textureDarkFloor2 });
  const materialWallSkull = new THREE.MeshLambertMaterial({ map: textureWallSkull });
  const materialWallSkull2 = new THREE.MeshLambertMaterial({ map: textureWallSkull2 });
  const materialGates = new THREE.MeshLambertMaterial({ map: textureGates });
  const materialFire = new THREE.MeshLambertMaterial({
    map: textureFire,
    transparent: true,
    opacity: 0.9
  });
  const materialSkull = new THREE.MeshPhongMaterial({ map: textureSkull });

  const offset = map.length / 2;
  const height = 2;
  const floorDistance = 0.55;
  const cloud1 = []; // Cloud points for tower 1
  const cloud2 = []; // Cloud points for tower 2

  for (let i = 0; i <= 15; i += 0.1) {
    if (i <= 6) {
      cloud1.push(new THREE.Vector2(1.5 + i * 0.1, i));
    } else if (i > 6 && i <= 14) {
      cloud1.push(new THREE.Vector2(Math.sin(i) * (i - 0.7 * i), i));
    } else {
      cloud1.push(new THREE.Vector2(4 * (15 - i), i));
    }
  }

  for (let i = 0; i <= 15; i += 0.1) {
    if (i <= 5) {
      cloud2.push(new THREE.Vector2(1.5 + i * 0.1, i));
    } else if (i > 5 && i <= 10) {
      cloud2.push(new THREE.Vector2(Math.cos(i) * 2, i));
    } else if (i > 10 && i <= 14) {
      cloud2.push(new THREE.Vector2(2 + (i - 10) * 0.2 - (2 - (i - 5) * 0.2), i));
    } else {
      cloud2.push(new THREE.Vector2(3 * (15 - i), i));
    }
  }

  const geometryFirstSection = new THREE.Geometry();
  const geometrySecondSection = new THREE.Geometry();
  const geometryThirdSection = new THREE.Geometry();
  const geometryFourthSection = new THREE.Geometry();
  const geometryDoorSection = new THREE.Geometry();
  let hero = null;

  for (let i = 0; i < map.length; i++) {
    for (let j = 0; j < map.length; j++) {
      if (map[i][j] === "p") {
        // First section of maze walls
        const wall = new Wall(j - offset, height / 2 - floorDistance, i - offset, height);
        wall.updateMatrix();
        geometryFirstSection.merge(wall.geometry, wall.matrix);
      } else if (map[i][j] === "q") {
        // Second section of maze walls
        const wall = new Wall(j - offset, height / 2 - floorDistance, i - offset, height);
        wall.updateMatrix();
        geometrySecondSection.merge(wall.geometry, wall.matrix);
      } else if (map[i][j] === "r") {
        // Third section of maze walls
        const wall = new Wall(j - offset, height / 2 - floorDistance, i - offset, height);
        wall.updateMatrix();
        geometryThirdSection.merge(wall.geometry, wall.matrix);
      } else if (map[i][j] === "s") {
        // Fourth section of maze walls
        const wall = new Wall(j - offset, height / 2 - floorDistance, i - offset, height);
        wall.updateMatrix();
        geometryFourthSection.merge(wall.geometry, wall.matrix);
      } else if (map[i][j] === "d") {
        // Doors sections of maze walls
        const wall = new Wall(j - offset, height / 2 - floorDistance, i - offset, height);
        wall.updateMatrix();
        geometryDoorSection.merge(wall.geometry, wall.matrix);
      } else if (map[i][j] === "h") {
        // Hero
        hero = new Hero(j - offset, 0, i - offset, scene, camera, vueBus, textureLoader);
      } else if (map[i][j] === "a") {
        const weapon = new Weapon(j - offset, 0, i - offset, hero, textureLoader);
        scene.add(weapon);
      } else if (map[i][j] === "T") {
        // Central tower
        const centralTowerGeometry = new THREE.LatheBufferGeometry(cloud1);
        const centralTower = new THREE.Mesh(centralTowerGeometry, materialDarkFloor);
        centralTower.position.set(j - offset - 0.5, -floorDistance, i - offset + 0.5);
        centralTower.name = "Wall";
        scene.add(centralTower);
      } else if (map[i][j] === "t") {
        // Fire tower
        const fireTowerGeometry = new THREE.LatheBufferGeometry(cloud2);
        const fireTower = new THREE.Mesh(fireTowerGeometry, materialFire);
        fireTower.position.set(j - offset - 0.5, -floorDistance, i - offset + 0.5);
        fireTower.name = "Wall";
        scene.add(fireTower);
      } else if (map[i][j] === "v") {
        // villain
        const villain = new Villain(
          j - offset + 0.35,
          0,
          i - offset,
          hero,
          offset,
          vueBus,
          textureLoader
        );
        scene.add(villain);
      }
    }
  }

  // Background
  const background = new Background(map.length * 3, camera, textureLoader);

  // Floor
  const floorShape = new THREE.Shape();
  floorShape.moveTo(-map.length / 2, -map.length / 2); // Floor shape of 50 x 50 centered to 0 0
  floorShape.lineTo(map.length / 2, -map.length / 2);
  floorShape.lineTo(map.length / 2, map.length / 2);
  floorShape.lineTo(-map.length / 2, map.length / 2);
  floorShape.lineTo(-map.length / 2, -map.length / 2);
  const floorGeometry = new THREE.ShapeBufferGeometry(floorShape);
  const floor = new THREE.Mesh(floorGeometry, materialSkull);
  floor.position.set(-0.5, -floorDistance, -0.5);
  floor.rotation.x = -Math.PI / 2;

  const wallFirstSection = new THREE.Mesh(
    new THREE.BufferGeometry().fromGeometry(geometryFirstSection),
    materialBlood
  );
  wallFirstSection.name = "Wall";
  const wallSecondSection = new THREE.Mesh(
    new THREE.BufferGeometry().fromGeometry(geometrySecondSection),
    materialDarkFloor2
  );
  wallSecondSection.name = "Wall";
  const wallThirdSection = new THREE.Mesh(
    new THREE.BufferGeometry().fromGeometry(geometryThirdSection),
    materialWallSkull
  );
  wallThirdSection.name = "Wall";
  const wallFourthSection = new THREE.Mesh(
    new THREE.BufferGeometry().fromGeometry(geometryFourthSection),
    materialWallSkull2
  );
  wallFourthSection.name = "Wall";
  const wallDoorSection = new THREE.Mesh(
    new THREE.BufferGeometry().fromGeometry(geometryDoorSection),
    materialGates
  );
  wallDoorSection.name = "Wall";

  scene.add(hero);
  scene.add(background);
  scene.add(floor);
  scene.add(wallFirstSection);
  scene.add(wallSecondSection);
  scene.add(wallThirdSection);
  scene.add(wallFourthSection);
  scene.add(wallDoorSection);

  hero.charge(0);

  return scene;
}
